import { Directive, HostListener, inject } from "@angular/core";
import { NgControl } from "@angular/forms";

@Directive({ selector: "[appTrimInput]" })
export class TrimInputDirective {
  private ngControl = inject(NgControl);

  @HostListener("blur")
  onBlur() {
    const current = this.ngControl.control?.value;
    if (typeof current === "string") {
      this.ngControl.control?.setValue(current.trim());
    }
  }
}
